import HandIcon from '@nv/images/design/hand-icon'
import clsx from 'clsx'
import styles from './AlertBanner.module.scss'

export const AlertBanner = ({ icon, text, error = false, success = false, color, actionButtons, infoPaneData }: any) => {
  if (error) icon = <HandIcon color='var(--error-color)' style={{ width: 50, height: 50 }} />

  return (
    <>
      <div
        className={clsx(styles['container'], {
          [styles['error']]: error,
          [styles['success']]: success,
        })}
        style={{ backgroundColor: color }}
      >
        <div className={styles['top-content']}>
          <div className={styles['icon']}>{icon}</div>
          <div className={styles['text']}>{text}</div>
        </div>
        {actionButtons && (
          <div className={styles['action-buttons']}>
            {Array.isArray(actionButtons) ? actionButtons.map((action, index) => <div key={index}>{action}</div>) : actionButtons}
          </div>
        )}
      </div>

      {infoPaneData && <div className={styles['info-pane']}>{infoPaneData}</div>}
    </>
  )
}
